<template>
   <canvas id="renderCanvas" ref="renderCanvas" @wheel="$event.preventDefault();" >
        <slot/>
    </canvas> 
</template>

<style>
    #renderCanvas {
        transition: 1s filter ease;
        outline: none;
    }
</style>

<script>
    import * as BABYLON from 'babylonjs';
    import { mapGetters,mapMutations} from 'vuex'
    import { Flux360LoadingScreen } from './Flux360LoadingScreen.js'
    import { Prefab } from "@/store/flux360/PrefabDataTypes";
    
    export default {
        data: () => ({
            engine: null,
            firstTime: true
         }),
        computed: {
            ...mapGetters(['currentSituation']),

            // checks if currentSituation contains panorama video and if so checks if neccessary video data is loaded 
            // needed to display mediaController UI properly
            isVideoPanorama(){
                //Check if currentSituation contains panorama video if not return false
                return this.currentSituation ? this.currentSituation.getType() == Prefab.PrefabType.SituationVideo: false;
            }
        },
        methods: {
            ...mapMutations(["setLoadingscreenVisible"]), //needed for Loadingscreen

            initialize() {
                console.log("Initializing Engine");
                this.engine = new BABYLON.Engine(this.$refs.renderCanvas, true);

                // init Loadingscreen
                this.engine.loadingScreen = new Flux360LoadingScreen(this);

                // Watch for Canvas resize event
                // window resize event wont work: it wont trigger when the sidebar opens/closes
                const resizeObserver = new ResizeObserver(() => {
                    // idk why but running resize in timeout function will prevent whitescreen flashing while resizing
                    setTimeout(() => {
                        this.engine.resize();
                        this.$store.commit('doRendering',true);
                    }, 0);
                });
                resizeObserver.observe(this.$refs.renderCanvas);
            },
            getEngine() {
                return this.engine;
            },
            getCanvas() {
                return this.$refs.renderCanvas;
            },
        },
        mounted: function() {
            console.log("Mounted Engine");
            this.$nextTick( () => {
                this.initialize();
            })
        },
        provide: function() {
            return {
                getEngine: this.getEngine,
                getCanvas: this.getCanvas
            }
        },
    }
</script>